// src/routes/taxRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Tax from '../pages/tax/Tax';
import ProtectedRoute from '../components/global/ProtectedRoute';

const taxRoutes = (
    <>
        <Route
            path="/tax"
            element={
                <ProtectedRoute requiredPermission="tax.manage">
                    <Tax />
                </ProtectedRoute>
            }
        />
    </>
);

export default taxRoutes;
